export default __webpack_public_path__ + "static/media/simobat.48a88c2f.png";